fx.ns("desktop.common.photoimport", class PhotoChoices extends shared.screens.BaseChoiceScreen  //extends fx.components.PopupPanel 
{

	constructor(mode) {
		super();

		// magic album (/create/magic) : a step before the MagicAlbumPanel, which the photos lead to
		// by themselves. Photos of this computer or of a phone only, and enough of them.
		let magic = fx.get("mode") == "creating-ia";

        this.showNext = fx.get("mode") == "creating";
		this.showBack = fx.get("mode") == "creating" || magic;

		this.mode = fx.get("mode") == "creating" || magic ? "navigate" : "popup";

		this._options = Object.assign(this.defaults, magic ? { google : false, file : false, albums : false } : {}, mode || {});

		this._magic = magic;
		this._bottomText = magic ? fx.text("Sélectionnez au minimum 24 photos") : "";
		this._containerHeight = magic ? 560 : 500;

		// the router keeps its views : this magic variant must not come back as the "Ajouter des
		// photos" popup once the album is placed and the editor open (mode "edition")
		this.destroyOnSwitch = magic;

        fx.service("GoogleService").initSDK();
	}

    get data()
    {
        return super.data;
    }

    set data(val)
    {
        if (val)
        {
            super.data = val.model ? val.model : val;
            this.photoComponent = val.component || null;
        }
    }

    get photoComponent()
    {
        return this._photoComponent;
    }

    set photoComponent(val)
    {
        this._photoComponent = val;
        fx.service("MediasUploader").photoComponent = val;
    }

	get bottomText() {
		return this._bottomText;
	}

	set bottomText(val) {
		this._bottomText = val;
	}


	get containerHeight() {
		return this._containerHeight;
	}

	set containerHeight(val) {
		this._containerHeight = val;
	}

	get defaults() {
		return { computer: true, mobile: true, facebook: false, google: true, instagram: false, file: true, albums: true }
	}

	get options() {
		return this._options;
	}

	get fileSelector() {
		if (!this._fileSelector) {
			this._fileSelector = fx.service("MediasUploader").fileSelector;
			this.on("files-selected", this.onFilesSelected, this._fileSelector);
		}
		return this._fileSelector;
	}

	get photoExtractor() {
		if (!this._photoExtractor)
			this._photoExtractor = fx.service("MediasUploader").photoExtractor;

		return this._photoExtractor;
	}

	get pdfSelector() {
		if (!this._pdfSelector) {
			this._pdfSelector = new fx.components.FileSelector({ fileTypes: [".pdf" /*, ".doc", ".docx", ".pptx"*/], multipleSelection: true });
			this.on("files-selected", this._onPdfSelected, this._pdfSelector);
			this.on("files-extension-error", this._onPdfExtensionError, this._pdfSelector);
		}

		return this._pdfSelector;
	}


    get container()
    {
        return this._container;
    }

	create() {
		super.create();

		this._container = new fx.components.Box();

		this._container.addChild(new shared.component.Person(fx.get("assets").splashPhoto), { width: 200, height: 200, top: 0, left: "center" });

		this.title = new fx.components.Text({ text: fx.text("Sélectionnez vos photos depuis :"), className: "title" });
		this._container.addChild(this.title, { height: 60, top: 220, left: "center" });

		this.hbox_main = new fx.components.HBox("sources");
		this._container.addChild(this.hbox_main, { height: 190, left: "center", top: 260 });

		if (this._options.computer) {
			let computerBox = new fx.components.Box("computer-box");
			this.computerButton = new fx.components.IconButton({ icon: fx.assets.computer, filled: true, className: "computer" })
			computerBox.addChild(this.computerButton, { width: 120, top: 10, left: "center" });
			computerBox.addChild(new fx.components.Text(fx.text("Votre ordinateur")), { width: "100%", height: 20, bottom: 0, left: 0 });
			this.hbox_main.addChild(computerBox, { width: 150, height: 170 });
		}

		if (this._options.mobile) {
			let mobileBox = new fx.components.Box("mobile-box");
			this.mobileButton = new fx.components.IconButton({ icon: fx.assets.mobile, filled: false, className: "mobile" })
			mobileBox.addChild(this.mobileButton, { width: 80, top: 30, left: "center" });
			mobileBox.addChild(new fx.components.Text(fx.text("Un mobile")), { width: "100%", height: 20, bottom: 0, left: 0 });
			this.hbox_main.addChild(mobileBox, { width: 120, height: 170 });
		}

		if (this._options.google) { 
			let googleBox = new fx.components.Box("google-box");
			this.googleButton = new fx.components.IconButton({ icon: fx.assets.google, filled: false, className: "google" });
			googleBox.addChild(this.googleButton, { width: 80, top: 30, left: "center" });
			googleBox.addChild(new fx.components.Text(fx.text("Google")), { width: "100%", height: 20, bottom: 0, left: 0 });
			this.hbox_main.addChild(googleBox, { width: 120, height: 170 });
		}

		if (this._options.file || this._options.albums) {
			let otherBox = new fx.components.Box("other-box");
			this.otherButton = new fx.components.IconButton({ icon: fx.assets.other, filled: false, className: "other" });
			otherBox.addChild(this.otherButton, { width: 80, top: 30, left: "center" });
			otherBox.addChild(new fx.components.Text(fx.text("Autre")), { width: "100%", height: 20, bottom: 0, left: 0 });
			this.hbox_main.addChild(otherBox, { width: 120, height: 170 });


			this.hbox_other = new fx.components.HBox("hbox-other");
			this.hbox_other.visibleAtStart = false;
			this._container.addChild(this.hbox_other, { height: 190, left: "center", top: 260 });

			this.backChoiceButton = new fx.components.IconButton({ className: "back", icon: fx.assets.previousIcon });
			this.hbox_other.addChild(this.backChoiceButton, { width: 80, top: 30 });

			if (this._options.file) {
				let fileBox = new fx.components.Box("file-box");
				this.fileButton = new fx.components.IconButton({ icon: fx.assets.file, filled: false, className: "file" });
				fileBox.addChild(this.fileButton, { width: 80, top: 30, left: "center" });
				fileBox.addChild(new fx.components.Text(fx.text("Fichier PDF")), { width: "100%", height: 20, bottom: 0, left: 0 });
				this.hbox_other.addChild(fileBox, { width: 120, height: 170 });
			}

			if (this._options.albums && this.data.account.isRegistered) {
				let albumsBox = new fx.components.Box("albums-box");
				this.albumButton = new fx.components.IconButton({ icon: fx.assets.albums, filled: false, className: "albums" });
				albumsBox.addChild(this.albumButton, { width: 80, top: 30, left: "center" });
				albumsBox.addChild(new fx.components.Text(fx.text("Vos Creations")), { width: "100%", height: 20, bottom: 0, left: 0 });
				this.hbox_other.addChild(albumsBox, { width: 120, height: 170 });
			}
		}

		if (this._options.instagram || this._options.facebook) {
			this.hbox_socialnetworks = new fx.components.HBox("hbox-socialnetworks");
			this.hbox_socialnetworks.visibleAtStart = false;
			this._container.addChild(this.hbox_socialnetworks, { height: 190, left: "center", top: 260 });
			this.backButton2 = new fx.components.IconButton({ className: "back", icon: fx.assets.previousIcon });
			this.hbox_socialnetworks.addChild(this.backButton2, { width: 80, top: 30 });

			if (this._options.facebook) {
				let facebookBox = new fx.components.Box("facebook-box");
				this.facebookButton = new fx.components.IconButton({ icon: fx.assets.facebook, filled: false, className: "facebook" });
				facebookBox.addChild(this.facebookButton, { width: 80, top: 30, left: "center" });
				facebookBox.addChild(new fx.components.Text(fx.text("Facebook")), { width: "100%", height: 20, bottom: 0, left: 0 });
				this.hbox_socialnetworks.addChild(facebookBox, { width: 120, height: 170 });
			}

			if (this._options.instagram) {
				let instagramBox = new fx.components.Box("instagram-box");
				this.instagramButton = new fx.components.IconButton({ icon: fx.assets.instagram, filled: false, className: "instagram" });
				instagramBox.addChild(this.instagramButton, { width: 80, top: 30, left: "center" });
				instagramBox.addChild(new fx.components.Text(fx.text("Instagram")), { width: "100%", height: 20, bottom: 0, left: 0 });
				this.hbox_socialnetworks.addChild(instagramBox, { width: 120, height: 170 });
			}
		}

		if (this.bottomText) {
			this.hintText = new fx.components.Text({ className: "bottom-text", text: this.bottomText });
			this._container.addChild(this.hintText, { width: "500", bottom: this._magic ? 45 : 0, left: "center" });
		}

		// magic album : photos already picked (back from the title screen) can be carried on with,
		// and their extraction is shown under the hint
		if (this._magic) {
			this.extractBar = new fx.components.ProgressBar({ showLabel : true });
			this.extractBar.addClass("extract-progress");
			this.extractBar.visibleAtStart = false;
			this._container.addChild(this.extractBar, { width : 460, height : 24, bottom : 0, left : "center" });

			this.magicNextButton = new fx.components.Button({ label : fx.text("Suivant") + " &gt;", className : "navigation" });
			this.magicNextButton.visibleAtStart = false;
			this.addChild(this.magicNextButton, { top : 0, right : 10 });
		}

		this.addChild(this._container, { top: "center", left : "center", width: "100%", height: this.containerHeight });
	}

	onReady() {
		super.onReady();

		if (this.computerButton)
			this.on("click", this.onComputerClick, this.computerButton);

		if (this.mobileButton)
			this.on("click", this.onMobileClick, this.mobileButton);

		if (this.facebookButton)
			this.on("click", this.onFacebookClick, this.facebookButton);

		if (this.instagramButton)
			this.on("click", this.onInstagramClick, this.instagramButton);

		if (this.googleButton)
			this.on("click", this.onGoogleClick, this.googleButton);

		if (this.fileButton)
			this.on("click", this.onFileClick, this.fileButton);

		if (this.albumButton)
			this.on("click", this.onAlbumClick, this.albumButton);

		if (this.socialNetworksButton)
			this.on("click", this.onSocialNetworksClick, this.socialNetworksButton);

		if (this.otherButton)
			this.on("click", this.onOtherClick, this.otherButton);

		if (this.backChoiceButton)
			this.on("click", this.onPreviousClick, this.backChoiceButton);

		if (this.backButton2)
			this.on("click", this.onPreviousClick, this.backButton2);

		this.on("ESCAPE", this.close, fx.keyboard);

		this.fileSelector.fileTypes = [".jpeg", ".jpg", ".png", ".heic"];

		if (this._magic) {
			let uploader = fx.service("MediasUploader");

			this.on("click", this._onMagicNext, this.magicNextButton);
			this.on("photo-extracted-started", this._updateMagicProgress, uploader);
			this.on("photo-extracted", this._updateMagicProgress, uploader);
			this.on("photo-extracted-finished", this._updateMagicProgress, uploader);

			this._updateMagicProgress();
		}
	}

	// magic album : "Suivant" as soon as photos are there (extracted, being sent or done), the
	// extraction progress while it lasts, then the hint block reads "XX photos sélectionnées"
	_updateMagicProgress() {
		if (!this.extractBar || !this.data)
			return;

		let uploader = fx.service("MediasUploader");
		let count = this.data.photos.active.length;
		let started = count > 0 || uploader.extracting || uploader.uploading;

		this.magicNextButton.toggle(started);

		if (uploader.extracting) {
			this.extractBar.show();
			this.extractBar.update(uploader.numExtracted, uploader.numFiles);
		}
		else
			this.extractBar.hide();

		if (this.hintText)
			this.hintText.text = (count > 0 && !uploader.extracting) ? fx.text("$ photos sélectionnées", count) : this.bottomText;
	}

	_onMagicNext() {
		this.data.event("next-step");
	}

	close() {
        if (this.data)
		    this.data.event("show-editor");
	}

	onPreviousClick() {
		this.hbox_main.removeClass("fadeOutLeft");
		this.hbox_main.addClass("fadeInRight");
		this.hbox_main.show();

		if (this.hbox_socialnetworks) {
			this.hbox_socialnetworks.removeClass("fadeInLeft");
			this.hbox_socialnetworks.addClass("fadeOutRight");
			this.hbox_socialnetworks.hide();
		}

		if (this.hbox_other) {
			this.hbox_other.removeClass("fadeInLeft");
			this.hbox_other.addClass("fadeOutRight");
			this.hbox_other.hide();
		}
	}

	onSocialNetworksClick() {
		this.hbox_main.removeClass("fadeInRight");
		this.hbox_main.addClass("fadeOutLeft");
		this.hbox_main.hide();

		if (this.hbox_socialnetworks) {
			this.hbox_socialnetworks.removeClass("fadeOutLeft");
			this.hbox_socialnetworks.addClass("fadeInLeft");
			this.hbox_socialnetworks.show();
			this.hbox_socialnetworks.viewport({ height: 190, left: "center", top: 260 });
		}

		if (this.hbox_other)
			this.hbox_other.hide();
	}

	onOtherClick() {
		this.hbox_main.removeClass("fadeInRight");
		this.hbox_main.addClass("fadeOutLeft");
		this.hbox_main.hide();

		if (this.hbox_socialnetworks)
			this.hbox_socialnetworks.hide();

		if (this.hbox_other) {
			this.hbox_other.removeClass("fadeOutLeft");
			this.hbox_other.addClass("fadeInLeft");
			this.hbox_other.show();
			this.hbox_other.viewport({ height: 190, left: "center", top: 260 });
		}
	}

	// photo import
	onComputerClick() {
		// The first time, we show a popup with more explanations
		if (!this.data.account.wasNotificated("selectFilesAlert")) {

			this._noticeSelectPopup = new shared.popups.NoticeSelectFiles();
			this.popup(this._noticeSelectPopup);
			this.on("closed", this.onComputerClick, this._noticeSelectPopup);
			this.data.account.notificated("selectFilesAlert");
		}
		else
			this.fileSelector.selectFiles();
	}

	onMobileClick() {
		this.data.event("import-mobile");
	}

	onFacebookClick() {
		this.data.event("import-facebook");
	}

	onInstagramClick() {
		this.data.event("import-instagram");
	}

	onGoogleClick() {
		fx.service("GoogleService").login();
	}

	onFileClick() {
		// show notice popup and wait for event == notice-select-pdf-closed
		this.pdfSelector.selectFiles();
	}

	onAlbumClick() {
		this.data.event("import-albums");
	}

	destroy() {
		super.destroy();

		this._fileSelector = null;
		this._fileExtractor = null;
	}

	onFilesSelected(event) {
		this.data.event("photos-files-selected");
	}

	_onPdfSelected(event) {
		this.data.event("show-editor");
		fx.service("PdfUploader").upload(event.detail);
	}

	_onPdfExtensionError(event) {
		this.popup(new common.popups.WrongFilePopup());
	}

});